import React from "react";
import Arab from "../../../../../Image/Arab.png";
import Dubai from "../../../../../Image/dubai.png";
import footprint from "../../../../../Image/footprint.png";
import Select from "./Select";

const InProgress = () => {
  return (
    <div className="tabelMain">
      <div className="card">
        <div className="card-heading card-heading1">
          <div>
            <h5>ID</h5>
          </div>
          <div>
            <h5 className="countryTitle">Dubai -UAE— Riyadh, Saudi Arabia</h5>
          </div>
          <div className="selected">
            <Select />
          </div>
        </div>
        <div className="card-heading">
          <div>
            <h5>ID: 704580</h5>
            <h5>13-Sep-2022 07:05</h5>
            <h5>LCL</h5>
            <h5>400 M3</h5>
          </div>
          <div>
            <h6>Services:</h6>
            <h6>Product:</h6>
            <h6>Loading Date:</h6>
          </div>
          <div>
            <h5>Road Transportation</h5>
            <h5>Texttiles</h5>
            <h5>30-Sep-2022 00:00</h5>
          </div>
          <div className="footprint_img">
            <img src={footprint} alt="footprint" />
            <span>100 g</span>
          </div>
        </div>
        <div className="card-heading">
          <div>
            <h5>Dubai</h5>
            <h6 className="country">United Arab Emirates</h6>
            <img width="40" height="25" src={Dubai} alt="" />
            <h5>Pickup</h5>
          </div>
          <div>
            <h5>Dubai</h5>
            <h6 className="country">United Arab Emirates</h6>
            <img width="40" height="25" src={Dubai} alt="" />
            <h5>Un-Loading</h5>
          </div>
          <div>
            <h5>Riyadh</h5>
            <h6 className="country">Saudi Arabia</h6>
            <img width="40" height="25" src={Arab} alt="" />
            <h5>Un-Loading</h5>
          </div>
          <div>
            <h5>Riyadh</h5>
            <h6 className="country">Saudi Arabia</h6>
            <img width="40" height="25" src={Arab} alt="" />
            <h5>Un-Loading</h5>
          </div>
        </div>
        <div className="user_dashboard_line"></div>
      </div>
    </div>
  );
};

export default InProgress;
